<template>
	<div class="module_page page_content institution" aria-label="Institution Packages view content page">

    	<div class="row page-heading">
      		<div class="col-7 input module_heading" role="heading" aria-level="1">
        		<span class="module_icon ic-inst"></span>
        		<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}} {{institution.orgType}}</label>
        		<!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        		<label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      		</div>
      		<div class="col-5 btn_container">
            <b-btn @click="doneClicked">done</b-btn>
            <b-btn @click="saveClicked">save</b-btn>
        		<b-btn @click="cancelClicked">cancel</b-btn>
      		</div>
    	</div>

    	<div class="page_content_container">

      		<institution-menu :uuid="uuid" :active="'packages'"></institution-menu>

      		<div class="row pg_content">
	      		<div class="col-12">
	        		<div class="row course-description pkg_bx_container">

	          			<template v-for="(packageObject, index) in formattedPackages">
		            		<div class="col-xl-4 col-lg-6 col-md-12 col-sm-12">
			            		<div class="pkg_entity_bx">
			            			<div class="bx_inner">
			            				<div class="thumbnail_container">
				              				<!-- <span id="packageLogo"></span> -->
				              				<div class="ic icon-explore" v-if="packageObject.title === 'Explore'"></div>
				              				<div class="ic icon-course" v-if="packageObject.title === 'Course Planning'"></div>
				              				<div class="ic icon-course" v-if="packageObject.title === 'External Courses'"></div>
				              				<div class="ic icon-meter" v-if="packageObject.title === 'Dashboard'"></div>
				              			</div>
				              			<div class="entity_title">
				              				<span id="packageTitle" class="entity_title_txt">{{packageObject.title}}</span>
				              				<span :id="'packageInfo_' + index" class="exclamation-circle"><span class="ico-error"></span></span>
				              			</div>
				              			<div class="btm_row">
				              				<switches v-model="packageStatus[packageObject.packageId].isEnabled" text-enabled="Yes" text-disabled="No"></switches>
				              			</div>
				              			<b-popover :target="'packageInfo_' + index" triggers="hover" :title="packageObject.description"></b-popover>
			              			</div>
			            		</div>
		            		</div>
	          			</template>

	        		</div>
	      		</div>
      		</div>

    	</div>

	</div>
</template>

<script>
import '../../../assets/module/sass/institution/institutionPackage.scss'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'administerInstitutionPackages',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      userObject: JSON.parse(localStorage.getItem('userobj')),
      userRole: localStorage.getItem('userrole'),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION',
      packageStatus: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'storeInstitution',
      'loadPackages',
      'loadInstitutionPackage',
      'loadUserAdvisor',
      'loadLogDashboardActivity'
    ]),
    loadData () {
      if (!this.isSuperAdmin) {
        this.redirectToKnockoutDashboard()
        return
      }
      this.loadPackages()
      this.loadInstitutionDetail(this.uuid)
      this.loadInstitutionPackage({uuid: this.uuid, isAggregated: false})
    },
    redirectToKnockoutDashboard () {
      window.location.href = this.knockoutDashboardHome
    },
    cancelClicked () {
      return this.$router.push({ name: 'institutionPackages', params: { uuid: this.uuid } })
    },
    saveClicked () {
      this.saveInstitutionObject()
    },
    async doneClicked () {
      await this.saveInstitutionObject()
      return this.$router.push({ name: 'institutionPackages', params: { uuid: this.uuid } })
    },
    async saveInstitutionObject () {
      let institution = this.institution
      let packagesToSave = this.packagesToSave
      const institutionData = {
        uuid: institution.uuid,
        title: institution.title,
        level: institution.level,
        description: institution.description,
        type: institution.type,
        orgType:institution.orgType,
        uri: institution.uri,
        address: institution.address,
        phonenumber: institution.phonenumber,
        faxnumber: institution.faxnumber,
        openId: institution.openId,
        logo: institution.logo,
        autoProvision: institution.autoProvision,
        autoProvisionRole: institution.autoProvisionRole,
        autoTaggingEnable: institution.autoTaggingEnable,
        courseDiscoveryConfigurationEnable: institution.courseDiscoveryConfigurationEnable,
        createPersonProfile: institution.createPersonProfile,
        customLandingPageViewer: institution.customLandingPageViewer,
        debugSearchRelevance: institution.debugSearchRelevance,
        employmentDataProvider: institution.employmentDataProvider,
        enableDashboard: institution.enableDashboard,
        enableExplore: institution.enableExplore,
        guestUserSessionCount: institution.guestUserSessionCount,
        lmsConnectorPackage: institution.lmsConnectorPackage,
        mc3Integration: institution.mc3Integration,
        nlpSearchEnable: institution.nlpSearchEnable,
        packages: packagesToSave,
        pollingTimeMessages: institution.pollingTimeMessages,
        pollingTimeNotifications: institution.pollingTimeNotifications,
        sharePlanningStream: institution.sharePlanningStream,
        showDefaultLandingPage: institution.showDefaultLandingPage,
        showDuplicateContent: institution.showDuplicateContent,
        streamPackage: institution.streamPackage,
        semesterMap: institution.semesterMap,
        yearMap: institution.yearMap,
        currentSemester: institution.currentSemester,
        emailRecipients: institution.emailRecipients,
        emailSender: institution.emailSender
      }
      this.showLoader()
      let response = await this.storeInstitution(institutionData)
      await this.loadInstitutionPackage({uuid: this.uuid, isAggregated: false})
      this.hideLoader()
      let isSuccessful = this.isSuccessfulResponse(response)
      let message = isSuccessful ? 'Packages updated successfully for' : 'Unable to update Packages for'
      let notify = isSuccessful ? this.notifySuccess : this.notifyFailure
      notify(message + ' \'' + institution.title + '\'')
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },
    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    isSuccessfulResponse (response) {
      return response && response.uuid
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    isPackageEnabled (packageObject) {
      let isEnabled = false
      let targetId = packageObject.packageId
      let institutionPackages = this.packages
      institutionPackages.forEach(currentPackage => {
        if (targetId === currentPackage.packageId) {
          isEnabled = true
        }
      })
      return isEnabled
    },
    togglePackage (packageObject) {
      packageObject.enabled = !packageObject.enabled
    },
    getPackage (packageObject, packages) {
      let targetPackage
      packages.forEach(currentPackage => {
        if (packageObject.packageId === currentPackage.packageId) {
          targetPackage = currentPackage
        }
      })
      return targetPackage
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'allPragyaPackages': state => state.institution.allPragyaPackages,
      'packages': state => state.institution.packages,
      'permission': state => state.user.permission,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    formattedPackages () {
      let formattedPackages = []
      let allPackages = this.allPragyaPackages
      if (!allPackages || allPackages.length <= 0) {
        return []
      }
      // copy package status to local data variable for v-switches binding
      let packageStatus = {}
      let isEnabled = this.isPackageEnabled
      allPackages.forEach(packageObject => {
        packageStatus[packageObject.packageId] = { data: packageObject, isEnabled: isEnabled(packageObject) }
        formattedPackages.push(packageObject)
      })
      this.packageStatus = packageStatus
      return formattedPackages
    },
    packagesToSave () {
      let packagesToSave = []
      // add every enabled package to the list of packages to be saved
      // save the original institution.package to avoid clearing features/flags/labels
      let institutionPackages = this.packages
      let packageStatus = this.packageStatus
      institutionPackages.forEach(packageObject => {
        let existingPackage = packageStatus[packageObject.packageId]
        if (existingPackage) {
          let isEnabled = existingPackage.isEnabled
          if (isEnabled) {
            packagesToSave.push(packageObject)
          }
        }
      })
      // if any new packages were enabled, add them to the package list to be saved
      let editedPackages = this.formattedPackages
      let getPackage = this.getPackage
      editedPackages.forEach(packageObject => {
        let institutionPackage = getPackage(packageObject, institutionPackages)
        let isNewPackage = !institutionPackage && packageStatus[packageObject.packageId].isEnabled
        if (isNewPackage) {
          packagesToSave.push(packageObject)
        }
      })
      return packagesToSave
    },
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/AdministerInstitutionPackages.vue